import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/Order.requests'

import simpleApi from 'app/services/simpleApi'
import {
    UpdateLocationRequestType,
} from '../../OrderSteps.types'

const useUpdateLocation = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessUpdateLocation,
        onError,
    } = useHandleStatusRequest({
        id: 'ModifyOrderStep',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            orderNumber,
            data,
        }: {
            data: UpdateLocationRequestType,
            orderNumber: string,
        }) => {
            return simpleApi({
                ...requests.updateCollectionDropoffPoint({
                    orderNumber,
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessUpdateLocation,
        onError,
    })
}

export default useUpdateLocation
